export default "__VITE_ASSET__Dkjy536s__"